<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card>
      <v-card-title>ESTIMACIÓN PRESUPUESTARIA</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col class="pa-0" cols="12" sm="6" md="3">
            <v-list class="py-0" dense>
              <v-list-item two-line dense>
                <v-list-item-content class="pa-0">
                  <v-list-item-title class="caption">Categoría</v-list-item-title>

                  <v-list-item-subtitle class="caption">{{ item?.categoria }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col class="pa-0" cols="12" sm="6" md="3">
            <v-list class="py-0" dense>
              <v-list-item two-line dense>
                <v-list-item-content class="pa-0">
                  <v-list-item-title class="caption">Nombre programa</v-list-item-title>

                  <v-list-item-subtitle class="caption">{{ item?.nombre_programa }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col class="pa-0" cols="12" sm="6" md="3">
            <v-list class="py-0" dense>
              <v-list-item two-line dense>
                <v-list-item-content class="pa-0">
                  <v-list-item-title class="caption">Usuario</v-list-item-title>

                  <v-list-item-subtitle class="caption">{{ item?.user }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col class="pa-0" cols="12" sm="6" md="3">
            <v-list class="py-0" dense>
              <v-list-item two-line dense>
                <v-list-item-content class="pa-0">
                  <v-list-item-title class="caption">Cantidad inscritos estimados</v-list-item-title>

                  <v-list-item-subtitle class="caption">{{ item?.cantidad_inscritos_estimada }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col class="pa-0" cols="12" sm="6" md="3">
            <v-list class="py-0" dense>
              <v-list-item two-line dense>
                <v-list-item-content class="pa-0">
                  <v-list-item-title class="caption">Número cuotas</v-list-item-title>

                  <v-list-item-subtitle class="caption">{{ item?.numero_cuotas }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col class="pa-0" cols="12" sm="6" md="3">
            <v-list class="py-0" dense>
              <v-list-item two-line dense>
                <v-list-item-content class="pa-0">
                  <v-list-item-title class="caption">Fecha inicio</v-list-item-title>

                  <v-list-item-subtitle class="caption">{{ item?.fecha_inicio }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col class="pa-0" cols="12" sm="6" md="3">
            <v-list class="py-0" dense>
              <v-list-item two-line dense>
                <v-list-item-content class="pa-0">
                  <v-list-item-title class="caption">Porcentaje deserción</v-list-item-title>

                  <v-list-item-subtitle class="caption">{{ item?.tasa_desercion }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col class="pa-0" cols="12" sm="6" md="3">
            <v-list class="py-0" dense>
              <v-list-item two-line dense>
                <v-list-item-content class="pa-0">
                  <v-list-item-title class="caption">Porcentaje contado</v-list-item-title>

                  <v-list-item-subtitle class="caption">{{ item?.porcentaje_contado }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col cols="12">
            <ag-grid-vue
              :gridOptions="gridOptions"
              class="ag-theme-balham ag-grid-table-estimacion-show"
              :columnDefs="columnDefs"
              :defaultColDef="{ ...defaultColDef, floatingFilter: false }"
              @grid-ready="onGridReady"
              :rowData="items"
              colResizeDefault="shift"
              :animateRows="false"
              :pagination="false"
              :rowClassRules="rowClassRules"
              @first-data-rendered="onFirstDataRendered"
              :pinnedBottomRowData="pinnedBottomRowData"
              :alwaysShowVerticalScroll="true"
              :suppressPaginationPanel="true">
            </ag-grid-vue>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import IngresoServices from '../services/ingresos';
import AgGridMixin from '../mixins/ag-grid-mixin';
import { aMonedaValueFormatter, formatearValorAMoneda } from '../utils';

export default {
  name: 'VerEstimacionIngreso',
  mixins: [AgGridMixin],
  data() {
    return {
      items: [],
      item: null,
      visible: false,
      columnDefs: [
        {
          headerName: 'Cuenta',
          field: 'partida',
          filter: false,
          minWidth: 350,
        },
        {
          headerName: 'Concepto Pago',
          field: 'concepto_pago',
          filter: false,
          minWidth: 120,
        },
        {
          headerName: 'ENERO',
          field: 'enero',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'FEBRERO',
          field: 'febrero',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'MARZO',
          field: 'marzo',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'ABRIL',
          field: 'abril',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'MAYO',
          field: 'mayo',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'JUNIO',
          field: 'junio',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'JULIO',
          field: 'julio',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'AGOSTO',
          field: 'agosto',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'SEPTIEMBRE',
          field: 'septiembre',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'OCTUBRE',
          field: 'octubre',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'NOVIEMBRE',
          field: 'noviembre',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'DICIEMBRE',
          field: 'diciembre',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
        },
        {
          headerName: 'TOTAL',
          field: 'total',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
        },
      ],
    };
  },
  computed: {
    pinnedBottomRowData() {
      return [
        {
          partida: `TOTAL(${this.item?.gestion?.numero})`,
          total: formatearValorAMoneda(this.item?.subtotal_gestion),
          bold: true,
        },
        {
          partida: `IMPORTE DESERCION(${this.item?.gestion?.numero})`,
          total: formatearValorAMoneda(this.item?.desercion_gestion),
          bold: true,
        },
        {
          partida: `INGRESO ESTIMADO(${this.item?.gestion?.numero})`,
          total: formatearValorAMoneda(this.item?.total_gestion),
          bold: true,
        },
      ];
    },
  },
  methods: {
    abrir(item) {
      this.visible = true;
      this.item = item;
      this.items = [];
      this.listar();
    },
    cerrar() {
      this.visible = false;
    },
    async listar() {
      try {
        const params = {
          gestion_id: this.item.gestion.id,
        };
        const response = await IngresoServices.show(this.item.id, { params });

        this.items = response.data.datos;
      } catch (error) {
        window.console.log(error);
      }
    },
  },
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-table-estimacion-show {
  height: calc(var(--vh, 1vh) * 100 - 23rem);
}
</style>
